import { render } from "./DetalharAulaReposicao.vue?vue&type=template&id=2f567ac6&scoped=true"
import script from "./DetalharAulaReposicao.vue?vue&type=script&lang=js"
export * from "./DetalharAulaReposicao.vue?vue&type=script&lang=js"

import "./DetalharAulaReposicao.vue?vue&type=style&index=0&id=2f567ac6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f567ac6"]])

export default __exports__